// extracted by mini-css-extract-plugin
export default {"container":"_quantitySelector_container__W3dTq","button":"_quantitySelector_button__uG9gX"};